import React from 'react';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Form, Field, reduxForm } from 'redux-form';
import { Input } from '../common/input';
import { NavLink } from 'react-router-dom';

//Return login page
const Login = props => {

  const { handleSubmit, onSubmit } = props;

  return (
    <div>
      <TabPanel tabId="login">
        <Form onSubmit={handleSubmit(onSubmit)}>
        <input type="text" style={{display:"none"}} />
      <input type="password" style={{display:"none"}}/>
          <div className="input_wrapper email_wrapper">
          <img src="../../../assets/images/ic_email.png"/>
            <Field
             name="email"
             label="Email ID"
             component={Input}
            //  validate={[required]}
             />
          </div>
          <div className="input_wrapper">
          <img src="../../../assets/images/ic_password.png"/>
            <Field 
             name="password"
             label="Password"
             type="password"
            //  type="password"
             component={Input}
            //  validate={[required]}
             />
          </div>
          <div>
            <button type="submit" style={{display: "none"}}> </button>
          </div>
          <div className="forgot_password">
          <NavLink to='/forgot'><div className="forgot-link">Forgot Password ?</div></NavLink>
          </div>
        </Form>
      </TabPanel>

    </div>
  )
}

export default reduxForm({ form: 'login' })(Login)



// WEBPACK FOOTER //
// ./web/components/signUp/login.js